<template>
  <div/>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

const store = useStore<RootState>();

defineOptions({
  name: 'dataLanguageGroupItems',
});

// Базовый тип для сообщений с ID элемента языковой группы
type LanguageGroupItemWithId = {
  idLanguageGroupItem: number;
};

// Типы для WebSocket сообщений компонента languageGroupItems
type LanguageGroupItemsListMessage = WebSocketMessageWithFields<'language-group-item-list', {
  languageGroupItems: unknown[];
}>;
type LanguageGroupItemCreateMessage = WebSocketMessageWithFields<'language-group-item-create' | 'language-group-item-create-success', LanguageGroupItemWithId & {
  idLanguageGroup: number;
  code: string;
}>;
type LanguageGroupItemDeleteMessage = WebSocketMessageWithFields<'language-group-item-delete' | 'language-group-item-delete-success', LanguageGroupItemWithId>;
type LanguageGroupItemTranslationsMessage = WebSocketMessageWithFields<'language-group-item-translations', {
  languageGroupItem: unknown;
}>;

// Объединенный тип для всех сообщений
type LanguageGroupItemsWebSocketMessage = 
  | LanguageGroupItemsListMessage 
  | LanguageGroupItemCreateMessage 
  | LanguageGroupItemDeleteMessage 
  | LanguageGroupItemTranslationsMessage;

// WebSocket message handler
const handleWebSocketMessage = (data: LanguageGroupItemsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'language-group-item-list':
      store.dispatch('languageGroupItems/wsSetLanguageGroupItems', { languageGroupItems: data.languageGroupItems });
      break;

    case 'language-group-item-create':
    case 'language-group-item-create-success':
      store.dispatch('languageGroupItems/wsLanguageGroupItemCreate', {
        idLanguageGroupItem: data.idLanguageGroupItem,
        idLanguageGroup: data.idLanguageGroup,
        code: data.code,
      });
      break;

    case 'language-group-item-delete':
    case 'language-group-item-delete-success':
      store.dispatch('languageGroupItems/wsLanguageGroupItemDelete', { idLanguageGroupItem: data.idLanguageGroupItem });
      break;

    case 'language-group-item-translations':
      store.dispatch('languageGroupItem/wsSetLanguageGroupItem', data.languageGroupItem);
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);
</script>
